import { gql } from "@apollo/client";
import { createPageInfo } from "./helper";

export const typeDef = gql`
  type CanvasStructure {
    type: String
    id: Int
  }

  type CanvasPageMeta {
    title: String
    keywords: String
    description: String
    robots: String
  }

  type CanvasStructureConnection {
    data: [CanvasStructure]
    meta: CanvasPageMeta
    pageInfo: PageInfo
  }

  type Query {
    canvas(idKey: String, offset: Int, limit: Int): CanvasStructureConnection
  }
`;

export const resolvers = {
  Query: {
    canvas: async (_parent, { idKey, offset, limit }, { dataSources }) => {
      try {
        const res = await dataSources.canvas.getCanvas(idKey);
        const structure = res.structure;
        const meta = {
          title: res.name,
          ...res.values?.meta,
        };
        return {
          data: structure.slice(offset, offset + limit),
          meta,
          pageInfo: createPageInfo({
            limit,
            offset,
            count: structure.length,
          }),
        };
      } catch (e) {
        console.log("canvas schema query error", e);
      }
    },
  },
};
